import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import DataCollectionImage from "./assets/Logo.jpg"; // Correct path for the image
// Another example asset

// Styled components
const PrivacyPolicyContainer = styled.div`
  padding: 20px;
  max-width: 900px;
  margin: auto;
  font-family: "Arial, sans-serif";
  background-color: #000;
  color: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 12px rgba(0, 0, 0, 0.2);
`;

const Header = styled(motion.h1)`
  text-align: center;
  color: #ff0000; /* Bright red for the header */
  font-size: 3rem;
  font-weight: bold;
  margin-bottom: 20px;
`;

const Section = styled(motion.div)`
  margin: 20px 0;
  background: rgba(255, 255, 255, 0.1);
  padding: 15px 20px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
`;

const Title = styled.h2`
  font-size: 1.8rem;
  color: #ff0000; /* Bright red for section titles */
  margin-bottom: 10px;
`;

const Text = styled.p`
  line-height: 1.6;
  font-size: 1rem;
  color: #fff; /* White text for descriptions */
`;

const Image = styled(motion.img)`
  width: 100%;
  border-radius: 8px;
  margin: 20px 0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);
`;



// Component
const PrivacyPolicy = () => {
  return (
    <PrivacyPolicyContainer>
      <Header
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        Mercy Hands
      </Header>

      <Section
        initial={{ opacity: 0, x: -100 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Title>Who We Are</Title>
        <Text>
          <strong>We are helping people</strong> through blood donations, food
          donations, and supporting orphanages with genuine care and dedication.
        </Text>
      </Section>

      <Section
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <Title>Information We Collect</Title>
        <Text>
          We gather details to facilitate our mission effectively and ensure a
          seamless experience for donors and recipients.
        </Text>
        <Image
          src={DataCollectionImage}
          alt="Data Collection"
          initial={{ opacity: 0.5, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          whileHover={{ scale: 1.1, rotate: 2 }}
        />
        <ul>
          <li>Account Information: Name, email, phone number.</li>
          <li>Donation Details: Type, amount, and recipient details.</li>
          <li>Orphanage Details: Orphanage name, address, and contact info.</li>
          <li>Device Information: Type, operating system, and unique ID.</li>
        </ul>
      </Section>

      <Section>
        <Title>Privacy Policy</Title>
        <Text>
          At <strong>Mercy Hands</strong>, we strictly ensure that all collected
          data is used ethically and responsibly:
        </Text>
        <ul>
          <li>No misuse of blood donations or recipient details.</li>
          <li>No misuse of food donations for personal or unauthorized purposes.</li>
          <li>Orphanage details are handled with utmost confidentiality.</li>
          <li>We comply with all relevant data protection laws and standards.</li>
        </ul>
        <Text>
          By engaging with us, you trust us with your data. We ensure its
          responsible use to support our humanitarian efforts.
        </Text>
      </Section>

      <Section>
        <Title>Contact Us</Title>
        <Text>
          For any questions, feel free to reach out at:
          <strong style={{ color: "#ff0000" }}> privacy@mercyhands.com</strong>
        </Text>
      </Section>
    </PrivacyPolicyContainer>
  );
};

export default PrivacyPolicy;
